import React from 'react'
import { CircularProgress, CircularProgressProps } from '@material-ui/core'

export const Loader: React.FC<CircularProgressProps> = (
  props: CircularProgressProps
): React.ReactElement => {
  const { size = 40, ...rest } = props
  return <CircularProgress size={size} {...rest} />
}
